import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DropdownPortal } from "./DropdownPortal";

// Localized strings
const STRINGS = {
  en: {
    more: "More",
    help: "Help",
    answerTracker: "Answer Tracker",
    reset: "Reset",
    exitGame: "Exit Game",
  },
  es: {
    more: "Más",
    help: "Ayuda",
    answerTracker: "Seguimiento de Respuestas",
    reset: "Reiniciar",
    exitGame: "Salir del Juego",
  }
};

export function MoreMenu({ onHelp, onTracker, onReset, lang = "en" }) {
  const t = STRINGS[lang] || STRINGS.en;
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const navigate = useNavigate();

  const handleExit = () => {
    if (typeof window.saveProgress === "function") {
      window.saveProgress();
    }
    setOpen(false);
    navigate("/", { replace: true });
  };

  return (
    <div className="relative">
      <button
        ref={btnRef}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md ring-1 ring-black/5 hover:bg-black/5"
        aria-haspopup="menu"
        aria-expanded={open ? "true" : "false"}
        onClick={() => setOpen((v) => !v)}
        title={t.more}
      >
        ⋯
      </button>

      <DropdownPortal anchorEl={btnRef.current} open={open} onClose={() => setOpen(false)}>
        <button
          className="w-full text-left px-3 py-2 hover:bg-black/5"
          onClick={() => { setOpen(false); onHelp?.(); }}
        >
          {t.help}
        </button>
        {/* Answer Tracker - only show in English version */}
        {lang === "en" && (
          <button
            className="w-full text-left px-3 py-2 hover:bg-black/5"
            onClick={() => { setOpen(false); onTracker?.(); }}
          >
            {t.answerTracker}
          </button>
        )}
        <button
          className="w-full text-left px-3 py-2 hover:bg-black/5"
          onClick={() => { setOpen(false); onReset?.(); }}
        >
          {t.reset}
        </button>

        <div className="border-t border-slate-200 my-1"></div>

        <button
          className="w-full text-left px-3 py-2 hover:bg-black/5 text-amber-700 font-medium"
          onClick={handleExit}
        >
          {t.exitGame}
        </button>
      </DropdownPortal>
    </div>
  );
}
